import { ResponseHandler } from "@king-ict/eupisi-ui/components";
import "./App.css";

import { Footer } from "../components/Footer/Footer";
import Layout from "../features/Layout";
import { LoginMenu } from "../features/Login";
import { useAuth } from "../hooks";
import Routing from "../routes/Routing";

function App() {
  require("../variablesImpared.scss");

  const auth = useAuth();

  if (!auth.authenticated) {
    return (
      <div>
        <LoginMenu />
        <Footer></Footer>
      </div>
    );
  }

  return (
    <Layout>
      <ResponseHandler closeOnConfirm={true} />
      <Routing />
    </Layout>
  );
}
export default App;
